import { render } from "./shakhsi.vue?vue&type=template&id=411444f2"
import script from "./shakhsi.vue?vue&type=script&lang=js"
export * from "./shakhsi.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/vhosts/localhost/storage/app/public/mixitweb-site/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__